import { render, staticRenderFns } from "./SettingsBotSnippet.vue?vue&type=template&id=086d281d&"
import script from "./SettingsBotSnippet.vue?vue&type=script&lang=js&"
export * from "./SettingsBotSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports